import { EventrDate } from '@eventr/common'
import { useEffect, useMemo, useState } from 'react'
import i18n from '../../../i18n/i18next'
import { useFormatTranslation } from '../hooks/useFormatTranslation'
import { CardText, ICardTextProps } from '../subComponents/cardText'

interface DisplayLabelProps {
    label?: string
    labelTime?: string
    overrideLabel?: string
    textProps?: ICardTextProps
}

export const DisplayLabel = ({
    label,
    labelTime,
    overrideLabel,
    textProps,
}: DisplayLabelProps) => {
    const { formatTranslation } = useFormatTranslation()
    const [displayLabel, setDisplayLabel] = useState(true)
    const [countdown, setCountdown] = useState('')

    useEffect(() => {
        if (!labelTime) return

        const updateCountdown = () => {
            const cardTime = new EventrDate(labelTime)

            const now = new EventrDate()

            const distance = cardTime.getUnixMs - now.getUnixMs

            if (distance < 0) {
                setCountdown('Past')
                return 10000000
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24))
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            )
            const minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
            )
            const seconds = Math.floor((distance % (1000 * 60)) / 1000)

            if (days > 0) {
                setCountdown(`${days}d ${hours}h`)
            } else if (hours > 0) {
                setCountdown(`${hours}h ${minutes}m`)
            } else if (minutes > 0) {
                setCountdown(`${minutes}m ${seconds}s`)
            } else if (seconds > 0) {
                setCountdown(`${seconds}s`)
            } else {
                setCountdown('Live')
            }

            let nextInterval = 1000 // default to 1 second
            if (days > 0) {
                nextInterval = 1000 * 60 * 60 // update every hour
            } else if (hours > 0) {
                nextInterval = 1000 * 60 // update every minute
            } else if (minutes > 0) {
                nextInterval = 1000 // update every second
            }

            return nextInterval
        }
        const interval = setInterval(() => {
            const nextInterval = updateCountdown()
            clearInterval(interval)
            setInterval(updateCountdown, nextInterval)
        }, 1000)

        return () => clearInterval(interval)
    }, [labelTime])

    const handleClick = (event: React.MouseEvent) => {
        if (labelTime) {
            setDisplayLabel(!displayLabel)
        }
        event.stopPropagation()
    }
    const text = useMemo(() => {
        const labelText =
            label === 'allDaySession'
                ? i18n.t('cards.allDaySession')
                : overrideLabel ||
                  (label &&
                      formatTranslation(label, { transType: 'labelWithDate' }))
        return displayLabel ? labelText : countdown
    }, [label, overrideLabel, displayLabel, formatTranslation, countdown])

    return (
        <CardText
            {...textProps}
            variant="bodyBold"
            onClick={handleClick}
            textAlign={'right'}
        >
            {text}
        </CardText>
    )
}
